import { render } from "./ThicknessMeasurementsTable.vue?vue&type=template&id=5a123ec2&scoped=true"
import script from "./ThicknessMeasurementsTable.vue?vue&type=script&lang=js"
export * from "./ThicknessMeasurementsTable.vue?vue&type=script&lang=js"

import "./ThicknessMeasurementsTable.vue?vue&type=style&index=0&id=5a123ec2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a123ec2"]])

export default __exports__